export default {
    Get: {
        PERSON_MODEL: 'getPersonModel',
        CONTENT_BY_TAB: 'getContentByTabName'
    },
    Set: {
        INSERT_PERSON: 'insertPerson',
        ORIGIN_PERSON_MODEL: 'setOriginPersonModel',
        PERSON_MODEL: 'setPersonModel',
        UPDATE_PERSON: 'updatePerson',
        DELETE_PEOPLE: 'deletePeople',
        NEW_MODEL: 'setCreatingMode',
        ASSIGNVALUE: 'setValue',
        ASSIGNVALUE_TO_ORIGINOBJECT: 'setValueForOriginalObject',
        INITIATED_DATA_TABS: 'setInitiatedDataTabs'
    }
  };